'use strict';

// requirements for now:
// DOM node must have an ID
// see tss.js, vehicle-info.js and XSLs
define('lib/scroller',[
  'jquery',
  'lib/util/debounce',

  // side effect includes
  'isInViewport'
], function (
  $,
  debounce
) {
  var __sectionsViewed = [];

  return {
    timeoutId: undefined,
    delay: 1000,
    cancel: function markingSection() {
      window.clearTimeout(this.timeoutId);
    },

    add: function addSection(el, opts) {
      var self = this;
      var $el = $(el);
      var defaultOpts = {
        id: '#' + $el.attr('id'),
        tolerance: 285,
        after: function () { } // default no-op
      };
      var finalOpts = $.extend(defaultOpts, opts);
      if (!$el.length) {
        return;
      }

      function addScrollListen() {
        var scrollListen = debounce(function debounceScrollListen() {
          if ($el.is(':in-viewport(' + finalOpts.tolerance + ')')) {
            if (typeof self.timeoutId === 'number') {
              self.cancel();
            }

            if (__sectionsViewed.indexOf(defaultOpts.id) === -1) {
              // TODO: do we need to make sure it's STILL in the viewport here?
              self.timeoutId = setTimeout(function fromTimer() {
                finalOpts.after.apply(el, arguments); // keep context of this on provided el
                self.timeoutId = undefined;
                __sectionsViewed.push(defaultOpts.id);
                document.removeEventListener('scroll', scrollListen);
              }, self.delay);
            }
          }
        }, 250);

        document.addEventListener('scroll', scrollListen, { passive: true });
      }

      // TODO: Handle a page that only has a single component, and is never scrolled.
      // right now, on a number of pages, we just do pageLoads and dont add via scroll.
      // wait the delay, then see if its in view again?
      // not foolproof, but... better?
      addScrollListen();
    }
  };
});

